import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Tracking aktivieren (GA4/GTM später hier hinzufügen)
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    // Tracking blocken
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      background: 'rgba(255, 255, 255, 0.98)',
      backdropFilter: 'blur(20px)',
      borderTop: '1px solid #E2E8F0',
      boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      animation: 'fade-in-up 0.4s ease-out'
    }}>
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
            <div style={{ flex: 1 }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '700',
                color: '#1a202c',
                marginBottom: '8px'
              }}>
                Cookie-Einstellungen
              </h3>
              <p style={{
                fontSize: '15px',
                lineHeight: '1.6',
                color: '#4a5568'
              }}>
                Wir verwenden Cookies, um Ihnen ein optimales Nutzererlebnis zu bieten. Sie können Ihre Einstellungen jederzeit im Footer unter "Cookie-Einstellungen" ändern.
              </p>
            </div>
            <button
              onClick={() => setShowBanner(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#718096',
                cursor: 'pointer',
                padding: '8px'
              }}
            >
              <X size={24} />
            </button>
          </div>
          
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={handleAccept}
              className="btn-primary"
              style={{
                minHeight: '48px',
                fontSize: '16px',
                padding: '12px 32px'
              }}
            >
              Akzeptieren
            </button>
            <button
              onClick={handleDecline}
              className="btn-secondary"
              style={{
                minHeight: '48px',
                fontSize: '16px',
                padding: '12px 32px'
              }}
            >
              Ablehnen
            </button>
            <Link
              to="/datenschutz"
              style={{
                color: '#0891B2',
                fontSize: '15px',
                fontWeight: '600',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                padding: '12px 16px'
              }}
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
